import { createFileRoute } from '@tanstack/react-router'
import { motion } from 'motion/react'
import { BlinkingCursor } from '@/components/l'

export const Route = createFileRoute('/_protected/example-protected-route')({
  component: ExampleProtectedPage,
})

function ExampleProtectedPage() {
  return (
    <main className="min-h-screen bg-[#0a0a0a] pt-24 pb-12">
      <div className="max-w-4xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center"
        >
          <h1 className="text-3xl font-bold text-white font-mono mb-4">
            PROTECTED_ROUTE
            <BlinkingCursor className="text-[#9B87F5] ml-2" />
          </h1>
          <p className="text-[#8E9196] font-mono">
            // This is an example of a protected route
          </p>
          <pre className="font-mono text-[#9B87F5]/30 text-xs mt-8 inline-block">
            {`┌─────────────────────────────────────┐
│                                     │
│    AUTHENTICATED_ACCESS_ONLY        │
│                                     │
│    You can only see this page       │
│    because you are signed in.       │
│                                     │
└─────────────────────────────────────┘`}
          </pre>
        </motion.div>
      </div>
    </main>
  )
}
